/**
 * Contains Middleware functions used for routes
*/
import Api from "../apis/Api";
import Csrf from "../apis/Csrf";
import { store } from '../store/store'
import Constants from '../constants/index';
import router from "../router/index";
import Common from "../functions/index";

export default {
    /**
     * Checks whether the route that the user is trying to navigate is authenticated and authorized for that logged-in user
     * Used for all the users except Sparkfore Admin
    */
    async checkAuth(to, from, next) {

        let moodleCookie = await Csrf.getCookie();
        if (localStorage.getItem('token') && moodleCookie == localStorage.getItem('mdl_token')) {

            if (Common.isAuthorized(to.name)){
                next();
            }else{
                router.push({name:'ForbiddenErrorPage'});
            }

        } else {

            try {
                let data = await Api.post("/auth", { 'cookie': moodleCookie });
                data = data.data;

                if (data && data.success == true) {

                    if (data && data.data.token && data.data.user) {

                        localStorage.setItem('token', data.data.token);
                        localStorage.setItem('mdl_token', moodleCookie);
                        await store.commit('setAuthUser', data.data.user);

                        if (Common.isAuthorized(to.name)){
                            next();
                        }else{
                           router.push({name:'ForbiddenErrorPage'});
                        }
                    }

                } else {
                    //alert('You are not authorized to access this page');
                    window.location.href = store.getters.instanceUrl;

                }

            } catch (error) {
                console.log(error);
                throw error;
            }

        }

    },

    /**
     * Checks whether the route that the user is trying to navigate is authenticated and authorized for that logged-in user
     * Used ONLY for the Sparkfore Admin
    */
    async softCheckAuth(to, from, next) {
        const resp = await Api.post("/admin/checkauth", "{}", {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            }
        });

        if (resp.data.success && (resp.data.data.user.role_id == Constants.sparkforeadmin)) {

            await store.commit('setAuthUser', resp.data.data.user);
            await store.commit('setAuthUserRoles', ['Sparkfore Admin']);
            next();

        } else {
            window.location.href = store.getters.spInstanceVueURL + 'login';
        }

    }
}